import type { TRuleWithTheme } from '@ackee/fela';

import type { UseStarsStyles } from 'utils/hooks/useStars';

interface LineStyleProps extends UseStarsStyles {
    rotation?: number;
    right?: string;
    bottom?: string;
    animationName?: string;
}

export const line: TRuleWithTheme<LineStyleProps> = ({ theme: { colors }, color, width, rotation, top, left }) => ({
    position: 'absolute',
    top,
    left,
    background: color || colors.fuchsia,
    width: width || 200,
    height: 1,
    transform: `rotate(${rotation || -45}deg)`,
});

export const floatingLine: TRuleWithTheme<LineStyleProps> = ({ animationName, animationTimeMS }) => ({
    animation: `${animationTimeMS}ms ${animationName} 1 linear`,
    animationFillMode: 'forwards',
    animationIterationCount: 'infinite',
});
